import axios from '../../../shared/http/customAxios';

class orderApprovedRepository {
	async checkReceivables(transaction: string) {
		try {
			const result = await axios().get(`/v1/order/${transaction}/approved`, {
				headers: { noAuthorization: true },
			});

			return result;
		} catch (error: any) {
			return error.response;
		}
	}
}

export default orderApprovedRepository;
